export default __webpack_public_path__ + "static/media/Rerebrace of Red Ruin (nm).b19142e6.jpg";